import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ValidationErrorsDialogData {
  /** Heading text, e.g. 'Cannot Create Request'. */
  title?: string;
  /** Intro line shown above the issue list. */
  message?: string;
  /** Human-readable items the user must complete (rendered as a list). */
  issues?: string[];
  /** Primary (dismiss) button label. Defaults to 'Continue Editing'. */
  confirmButtonText?: string;
}

/**
 * Informational modal that lists the validation errors blocking a save/create.
 * It only acknowledges and dismisses — the user resolves the issues on the form
 * behind it. Shared so any form can surface its validation issues consistently.
 */
@Component({
  selector: 'app-validation-errors-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './validation-errors-dialog.component.html',
  styleUrls: ['./validation-errors-dialog.component.scss'],
})
export class ValidationErrorsDialogComponent {
  dialogRef =
    inject<MatDialogRef<ValidationErrorsDialogComponent>>(MatDialogRef);
  data = inject<ValidationErrorsDialogData>(MAT_DIALOG_DATA);

  constructor() {
    this.data = this.data || {};
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
